import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO, NAVIGATION_NEW } from "data/navigation";

interface NavProps {
  isDark?: boolean;
}

function Navigation() {
  return (
    <ul className="nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:gap-0.5 relative">
      {NAVIGATION_DEMO.map((item) => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
}

export function NavigationNew({ isDark = false }: NavProps) {
  return (
    <ul className="nc-Navigation hidden lg:flex lg:items-center lg:gap-1 relative">
      {NAVIGATION_NEW.map((item) => (
        <NavigationItem key={item.id} menuItem={item} isDark={isDark} />
      ))}
    </ul>
  );
}

export default Navigation;
